import * as LoginActionTypes from "./LoginActionTypes";

export function authenticateRequestAction( data ) {

  return {
    type: LoginActionTypes.AUTHENTICATE_REQUEST,
    payload: data
  };
};

export function authenticateSuccessAction( data ) {
  return {
    type: LoginActionTypes.AUTHENTICATE_SUCCESS,
    payload: data
  };
};

export function authenticateFailAction( data ) {
  return {
    type: LoginActionTypes.AUTHENTICATE_FAIL,
    payload: data
  };
};

export function loginRequestAction( data ) {

  return {
    type: LoginActionTypes.LOGIN_REQUEST,
    payload: data
  };
};

export function loginSuccessAction( data ) {
  return {
    type: LoginActionTypes.LOGIN_SUCCESS,
    payload: data
  };
};

export function loginFailAction( data ) {
  return {
    type: LoginActionTypes.LOGIN_FAIL,
    payload: data
  };
};

export function logoutAction( ) {
  return {
    type: LoginActionTypes.LOGOUT_REQUEST
  };
};

export function loginErrorClearAction() {
  return {
    type: LoginActionTypes.LOGIN_ERROR_CLEAR
  }
}